import React, { useState, useEffect } from "react";
import { faChevronUp, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const sample = {
  projects: [
    {
      id: "PJT-001",
      name: "Divis Enclave • 5 units",
      initialBuildCoins: 0,
      categories: [
        { name: "Electrical PVC Pipes & Fittings", estOrderValue: 20000, actualOrderValue: 0, commissionPct: 5, buildCoinsPct: 1.25, redemptionPct: 1.25 },
        { name: "Electrical Metal Boxes", estOrderValue: 20000, actualOrderValue: 0, commissionPct: 5, buildCoinsPct: 1.25, redemptionPct: 1.25 },
        { name: "Elec DB", estOrderValue: 17500, actualOrderValue: 0, commissionPct: 5, buildCoinsPct: 1.43, redemptionPct: 1.43 },
        { name: "Elec Wires", estOrderValue: 0, actualOrderValue: 0, commissionPct: 0, buildCoinsPct: 0, redemptionPct: 0 },
        { name: "PVC, CPVC Pipes & Fittings ", estOrderValue: 0, actualOrderValue: 0, commissionPct: 0, buildCoinsPct: 0, redemptionPct: 0 },
        { name: "Construction Chemicals", estOrderValue: 25000, actualOrderValue: 0, commissionPct: 2, buildCoinsPct: 1, redemptionPct: 1 },
        { name: "Wall Putties & Textures", estOrderValue: 60000, actualOrderValue: 0, commissionPct: 1, buildCoinsPct: 0.4, redemptionPct:0.8},
        { name: "Paint Accessories", estOrderValue: 15000, actualOrderValue: 0, commissionPct: 0, buildCoinsPct: 0, redemptionPct: 0 },
        { name: "Tiles", estOrderValue: 0, actualOrderValue: 0, commissionPct: 0, buildCoinsPct: 0, redemptionPct: 0 },
        { name: "Windows", estOrderValue: 300000, actualOrderValue: 0, commissionPct: 1, buildCoinsPct: 0.3, redemptionPct: 0.7 },
        { name: "Tile Allied Products", estOrderValue: 75000, actualOrderValue: 0, commissionPct: 2, buildCoinsPct:0.3 , redemptionPct: 0.7 },
        { name: "Doors", estOrderValue: 600000, actualOrderValue: 0, commissionPct: 1, buildCoinsPct: 0.5, redemptionPct: 0.5 },
        { name: "Elec Switches", estOrderValue: 15000, actualOrderValue: 0, commissionPct: 2, buildCoinsPct: 3.3, redemptionPct: 0 },
        { name: "Elec Switchgear", estOrderValue: 15000, actualOrderValue: 0, commissionPct: 2, buildCoinsPct: 3.3, redemptionPct: 0 },
        { name: "Sanitary Fittings", estOrderValue: 25000, actualOrderValue: 0, commissionPct: 5, buildCoinsPct: 2, redemptionPct: 0 },
        { name: "Paints & Primers", estOrderValue: 0, actualOrderValue: 0, commissionPct: 0, buildCoinsPct: 0, redemptionPct: 0 },
      ],
    },
  ],
};

const fmt = (n, places = 0) =>
  isFinite(n)
    ? Number(n).toLocaleString("en-IN", {
        minimumFractionDigits: places,
        maximumFractionDigits: places,
      })
    : "0";

/* function computeAllCategories(categories,round = 0,formValues) {
  let runningLiability = Number(formValues.initialBuildCoins) || 0;
  let runningNet = Number(formValues.initialNet) || 0;
  const results = [];

  for (const cat of categories) {
    const result = computeCategory(cat, round,{
      initialBuildCoins:runningLiability,
      initialNet:runningNet
    });
    results.push(result);
    runningLiability = Number(result.estLiability);
    runningNet = Number(result.estNet);
  }
  return results
} */

  function computeCategoriesWithCarry(categories, initialLiability, round = 0) {
  let prevLiability = initialLiability || 0;
  const results = [];
  for (const cat of categories) {
    // Pass prevLiability as initialBuildCoins to computeCategory
    const res = computeCategory(cat, round, { initialBuildCoins: prevLiability });
    results.push(res);
    // Update prevLiability for next iteration
    prevLiability = res.estLiability;
  }
  return results;
}

/**
 * computeCategory:
 * - commissionPct, buildCoinsPct, redemptionPct are percentages (e.g. 1 => 1%)
 * - returns estCommission, estBuildCoins, estRedemption, estGross, estLiability, estNet
 */
function computeCategory(cat, round = 0,formValues,initialNet = 0) {
  const est = +cat.estOrderValue || 0;
  const cp = +cat.commissionPct || 0;
  const bp = +cat.buildCoinsPct || 0;
  const rp = +cat.redemptionPct || 0;

  const estCommission = (est * cp) / 100;   // total commission earned
  // Rewards: prefer fixedReward if present, else percentage
  const estBuildCoins = cat.fixedReward != null 
    ? +cat.fixedReward 
    : (est * bp) / 100;  // rewards issued
  // Redemption: prefer fixedRedemption if present, else percentage
  const estRedemption = cat.fixedRedemption != null 
    ? +cat.fixedRedemption 
    : (est * rp) / 100;  // rewards redeemed

  const estGross = estCommission;                  // gross = total commission

  //previous carry-forwards
  const prevLiability = Number(formValues.initialBuildCoins) || 0;
  //const prevNet = Number(initialNet) || initialNet;

  const estLiability = prevLiability  - estRedemption + estBuildCoins; 
  const estNet = estGross - estRedemption;          

  return {
    estOrder: est,
    estCommission: round != null ? +estCommission?.toFixed(round) : estCommission,
    estBuildCoins: round != null ? +estBuildCoins?.toFixed(round) : estBuildCoins,
    estRedemption: round != null ? +estRedemption?.toFixed(round) : estRedemption,
    estGross: round != null ? +estGross?.toFixed(round) : estGross,
    estLiability: round != null ? + estLiability?.toFixed(round) : estLiability,
    estNet: round != null ? +estNet?.toFixed(round) : estNet,
  };
}

export default function Simulator() {
  const [data, setData] = useState(sample);
  const [jsonInput, setJsonInput] = useState(JSON.stringify(sample, null, 2));
  const [rounding, setRounding] = useState(0);
  const [totals, setTotals] = useState({
    GOV: 0,
    comm: 0,
    awarded: 0,
    init: 0,
    gross: 0,
    liability: 0,
    net: 0,
    redeemed: 0,
  });
  const [mode, setMode] = useState("expected"); // "expected" or "actual"
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showCategoryEditor, setShowCategoryEditor] = useState(false);
  const [formValues, setFormValues] = useState({
    initialBuildCoins: 0,
  });

  // Fetch real data when mode is "actual"
  useEffect(() => {
    if (mode === "expected") {
      setData(sample);
      setJsonInput(JSON.stringify(sample, null, 2));
      setError(null);
      setLoading(false);
    } else if (mode === "actual") {
      setLoading(true);
      setError(null);
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);

  const fetchData = async () => {
    setLoading(true);
    setError("");
    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_FORE_APILINK}/projects/get-project-buildcoins-simulator-data`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-token": token,
          },
        }
      );

      if (!response.ok) throw new Error(`Failed to fetch ${mode} data`);
      const result = await response.json();
      setData(result || { projects: [] });
    } catch (err) {
      console.error(err);
      setError(err.message || "Failed to fetch");
      setData({ projects: [] });
    } finally {
      setLoading(false);
    }
  };

  // Parse JSON input safely and update data state
  const updateDataFromJson = (jsonStr) => {
    try {
      const parsed = JSON.parse(jsonStr);
      setData(parsed);
      setError(null);
    } catch {
      setError("Invalid JSON");
    }
  };

  // Update JSON input when data changes
  useEffect(() => {
    setJsonInput(JSON.stringify(data, null, 2));
  }, [data]);

  // computeRedeemedPerCategory now uses category.redemptionPct (percentage) to compute est redemption amount per category
  function computeRedeemedPerCategory(project, rounding) {
    return project.categories.map((c) => {
      const m = computeCategory(c, rounding);
      return m.estRedemption;
    });
  }

  // Recalculate totals and update summary (sums across categories using redemptionPct)
  useEffect(() => {
    let newTotals = { GOV: 0, comm: 0, awarded: 0, init: 0, gross: 0, liability: 0, net: 0, redeemed: 0 };


       data.projects.forEach((p) => {
  let sum = { est: 0, comm: 0, aw: 0, red: 0, lia: 0, net: 0 };
  const computedCats = computeCategoriesWithCarry(
    p.categories,
    p.initialBuildCoins ?? formValues.initialBuildCoins ?? 0,
    rounding
  );
  computedCats.forEach((m) => {
    sum.est += m.estOrder;
    sum.comm += m.estCommission;
    sum.aw += m.estBuildCoins;
    sum.red += m.estRedemption;
    sum.lia += m.estLiability;
    sum.net += m.estNet;
  });

      //const initialBuildCoins = p.initialBuildCoins || 0;
      const awarded = sum.aw; // BuildCoins awarded from categories only
      const redeemed = sum.red; // total redemption for project (sum of category estRedemption)
      const gross = sum.comm; // total commission earned

      // Liability includes initial BuildCoins + awarded - redeemed
      //const liability = formValues.initialBuildCoins + awarded - redeemed;

    // Net = gross commission - redeemed (do not subtract liability again)
      //const net = gross - liability - redeemed /* - liability */;

      newTotals.GOV += sum.est;
      newTotals.comm += sum.comm;
      newTotals.awarded += awarded;
      newTotals.init += formValues.initialBuildCoins;
      newTotals.gross += gross;
      newTotals.liability += sum.lia;
      newTotals.net += sum.net;
      newTotals.redeemed += redeemed;
    });
    setTotals(newTotals);
  }, [data, rounding,formValues.initialBuildCoins]);

  // Handlers
  const handleLoadSample = () => {
    setMode("expected");
    setData(sample);
    setJsonInput(JSON.stringify(sample, null, 2));
    setError(null);
  };

  const handlePrettify = () => {
    try {
      const pretty = JSON.stringify(JSON.parse(jsonInput), null, 2);
      setJsonInput(pretty);
      updateDataFromJson(pretty);
    } catch {
      setError("Invalid JSON");
    }
  };

  const handleRecalc = () => {
    updateDataFromJson(jsonInput);
  };

  const handleJsonInputChange = (e) => {
    setJsonInput(e.target.value);
  };

  const handleProjectInitialBuildCoinsChange = (pIdx, val) => {
    const newData = { ...data };
    newData.projects[pIdx].initialBuildCoins = +val || 0;
    setData(newData);
  };

  const handleProjectRedeemedChange = (pIdx, val) => {
    const newData = { ...data };
    newData.projects[pIdx].redeemed = +val || 0;
    setData(newData);
  };

  // replace the old handleCategoryChange with this (keeps raw string while typing)
  const handleCategoryChange = (pIdx, cIdx, key, val) => {
    setData(prev => {
      const projects = prev.projects.map((proj, i) => {
        if (i !== pIdx) return proj;
        return {
          ...proj,
          categories: proj.categories.map((cat, j) => {
            if (j !== cIdx) return cat;
            // keep raw string while typing for numeric fields
            return { ...cat, [key]: key === "name" ? val : val };
          }),
        };
      });
      return { ...prev, projects };
    });
  };

  // call this on blur to normalize/parse the typed value into a Number (or 0)
  const handleCategoryBlur = (pIdx, cIdx, key) => {
    setData(prev => {
      const projects = prev.projects.map((proj, i) => {
        if (i !== pIdx) return proj;
        return {
          ...proj,
          categories: proj.categories.map((cat, j) => {
            if (j !== cIdx) return cat;
            if (key === "name") return cat;

            const raw = String(cat[key] ?? "").trim();
            if (raw === "") return { ...cat, [key]: 0 };

            // allow comma as decimal separator, strip other junk
            const normalized = raw.replace(/,/g, ".").replace(/[^\d.\-]/g, "");

            const parsed = Number(normalized);
            return { ...cat, [key]: Number.isNaN(parsed) ? 0 : parsed };
          }),
        };
      });
      return { ...prev, projects };
    });
  };

  // Download helpers
  const download = (name, text) => {
    const a = document.createElement("a");
    a.href = "data:text/plain;charset=utf-8," + encodeURIComponent(text);
    a.download = name;
    a.click();
  };

  const downloadJSON = () => {
    download("brickbucket.json", jsonInput);
  };

  const downloadCSV = () => {
    const round = +rounding || 0;
    let rows = [
      [
        "ProjectID",
        "ProjectName",
        "InitialBuildCoins",
        "Category",
        "EstOrder",
        "CommissionPct",
        "RewardPct",
        "RedemptionPct",
        "EstCommission",
        "EstBuildCoins",
        "EstRedemption",
        "Gross",
        "Liability",
        "Net",
      ],
    ];

    data.projects.forEach((p) => {
      p.categories.forEach((c) => {
        const m = computeCategory(c, round,formValues);
        rows.push([
          p.id,
          p.name,
          p.initialBuildCoins || 0,
          c.name,
          c.estOrderValue,
          c.commissionPct,
          c.buildCoinsPct,
          c.redemptionPct,
          m.estCommission,
          m.estBuildCoins,
          m.estRedemption,
          m.estGross,
          m.estLiability,
          m.estNet,
        ]);
      });
    });

    const csv = rows.map((r) => r.join(",")).join("\n");
    download("brickbucket.csv", csv);
  };

const handleCoinsChange = (field, value) => {
  const valNum = Number(value) || 0;
  setFormValues((prev) => ({
    ...prev,
    [field]: value,
  }));

if (field === "initialBuildCoins") {
  setData(prev => ({
    ...prev,
    projects: prev.projects.map(p => ({
      ...p,
      initialBuildCoins: valNum
    }))
  }));
}

};



  return (
    <div className="min-h-screen bg-gradient-to-b from-[#061025] to-[#0b162e] text-[#eef3fa] font-sans">
      <header className="sticky top-0 bg-[rgba(6,16,37,0.75)] border-b border-white/5 backdrop-blur-md z-10">
        <div className="max-w-[1250px] mx-auto px-5 py-4 flex items-center gap-4">
          <div>
            <h1 className="text-xl font-semibold text-[#f9fafb]">Brickbucket • BuildCoins & Commission Simulator</h1>
            <div className="text-xs text-[#9aa4b2]">Adjust BuildCoins, commissions & project KPIs. Client-side only. (Estimates only)</div>
          </div>

          <div className="ml-auto flex items-center gap-4">
            <div className="ml-auto flex items-center space-x-4">
              <span className="text-sm font-semibold text-[#eef3fa] select-none">Expected</span>
              <button
                type="button"
                onClick={() => setMode(mode === "expected" ? "actual" : "expected")}
                aria-pressed={mode === "actual"}
                className={`relative inline-flex h-6 w-12 items-center rounded-full transition-colors ${mode === "actual" ? "bg-blue-600" : "bg-gray-600"}`}
              >
                <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${mode === "actual" ? "translate-x-6" : "translate-x-1"}`} />
              </button>
              <span className="text-sm font-semibold text-[#eef3fa] select-none">Actual</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-[1250px] mx-auto px-5 py-6 space-y-6">
        {loading && <div className="text-center text-yellow-400 font-semibold mb-4">Loading actual data...</div>}
        {error && <div className="text-center text-red-500 font-semibold mb-4">{error}</div>}

        <div className="w-full">
          <div className="flex justify-between">
            <span>Seed Buildcoins</span>
            <input
              type="text"
              inputMode="decimal"
              value={String(formValues.initialBuildCoins ?? "")}
              onChange={(e) =>
                handleCoinsChange("initialBuildCoins", e.target.value)
              }
              className="w-1/2 bg-[#0f1d38] border border-white/10 rounded-lg px-2 py-1 text-[#eef3fa]"
              disabled={loading}
            />
          </div>
        </div>

        <div className="w-full">
          <section className="bg-gradient-to-b from-white/3 to-white/1.5 rounded-xl p-4 flex-[0.9] min-w-[280px] border border-white/10 shadow-[0_8px_30px_rgba(2,6,23,0.6)]">
            <div className="flex justify-between items-center p-4 cursor-pointer" onClick={() => setShowCategoryEditor(!showCategoryEditor)}>
              <h2 className="text-lg font-semibold text-[#f9fafb]">Per-Category Editor</h2>
              <FontAwesomeIcon icon={showCategoryEditor ? faChevronUp : faChevronDown} className="text-white text-lg font-bold" />
            </div>

            {showCategoryEditor && (
              <div className="p-4 max-h-[1260px] overflow-auto">
                <table className="w-full border-collapse text-sm">
                  <thead>
                    <tr className="border-b border-white/10 text-[#9aa4b2] uppercase text-xs">
                      <th className="text-left py-2 px-3">Category</th>
                      <th className="text-left py-2 px-3">Order Value</th>
                      <th className="text-left py-2 px-3">Comm (%)</th>
                      <th className="text-left py-2 px-3">Reward (%)</th>
                      <th className="text-left py-2 px-3">Redeem (%)</th>
                      <th className="text-left py-2 px-3">Gross Comm (₹)</th>
                      <th className="text-left py-2 px-3">BuildCoins Promise(₹)</th>
                      <th className="text-left py-2 px-3">BuildCoins Redeemed (₹)</th>
                      <th className="text-left py-2 px-3 cursor-pointer" title="Liability = Rewards issued − Redemption (based on GOV × redemption%)">Buildcoins Liability (₹)</th>
                      <th className="text-left py-2 px-3 cursor-pointer" title="Net = Gross − Redemption - Liability">Net Comm(₹)</th>
                    </tr>
                  </thead>
                  <tbody>
 {data.projects.map((p, pIdx) => {
  const computedCats = computeCategoriesWithCarry(
    p.categories,
    p.initialBuildCoins ?? formValues.initialBuildCoins ?? 0,
    rounding
  );
  return p.categories.map((c, cIdx) => {
    const m = computedCats[cIdx];
    return (
      <tr key={`${p.id}-${c.name}`} className="border-b border-white/10">
        <td className="py-2 px-3">{c.name}</td>
        <td className="py-2 px-3">
          <input
            type="text"
            inputMode="decimal"
            value={String(c.estOrderValue ?? "")}
            onChange={(e) =>
              handleCategoryChange(pIdx, cIdx, "estOrderValue", e.target.value)
            }
            onBlur={() => handleCategoryBlur(pIdx, cIdx, "estOrderValue")}
            className="w-full bg-[#0f1d38] border border-white/10 rounded-lg px-2 py-1 text-[#eef3fa]"
            disabled={loading}
          />
        </td>
        <td className="py-2 px-3">
          <input
            type="text"
            inputMode="decimal"
            value={String(c.commissionPct ?? "")}
            onChange={(e) =>
              handleCategoryChange(pIdx, cIdx, "commissionPct", e.target.value)
            }
            className="w-full bg-[#0f1d38] border border-white/10 rounded-lg px-2 py-1 text-[#eef3fa]"
            disabled={loading}
          />
        </td>
        <td className="py-2 px-3">
          <input
            type="text"
            inputMode="decimal"
            value={String(c.buildCoinsPct ?? "")}
            onChange={(e) =>
              handleCategoryChange(pIdx, cIdx, "buildCoinsPct", e.target.value)
            }
            className="w-full bg-[#0f1d38] border border-white/10 rounded-lg px-2 py-1 text-[#eef3fa]"
            disabled={loading}
          />
        </td>
        <td className="py-2 px-3">
          <input
            type="text"
            inputMode="decimal"
            value={String(c.redemptionPct ?? "")}
            onChange={(e) =>
              handleCategoryChange(pIdx, cIdx, "redemptionPct", e.target.value)
            }
            className="w-full bg-[#0f1d38] border border-white/10 rounded-lg px-2 py-1 text-[#eef3fa]"
            disabled={loading}
          />
        </td>
        <td className="py-2 px-3 font-mono text-sm">₹{fmt(m.estCommission)}</td>
        <td className="py-2 px-3 font-mono text-sm text-yellow-400">₹{fmt(m.estBuildCoins)}</td>
        <td className="py-2 px-3 font-mono text-sm text-red-400">₹{fmt(m.estRedemption)}</td>
        <td className="py-2 px-3 font-mono text-sm text-purple-400">₹{fmt(m.estLiability)}</td>
        <td className="py-2 px-3 font-mono text-sm text-pink-400">₹{fmt(m.estNet)}</td>
      </tr>
    );
  });
})}

                  </tbody>
                </table>
              </div>
            )}
          </section>
        </div>

        <div className="w-full">
          <section className="bg-gradient-to-b from-white/3 to-white/1.5 rounded-xl p-4 flex-[0.9] min-w-[280px] border border-white/10 shadow-[0_8px_30px_rgba(2,6,23,0.6)]">
            <h2 className="text-lg font-semibold mb-3 text-[#f9fafb]">Portfolio Overview</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-3">
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                <div className="text-xs text-[#9aa4b2] mb-1">Est GOV</div>
                <div className="font-semibold text-lg">₹{fmt(totals.GOV)}</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                <div className="text-xs text-[#9aa4b2] mb-1">Est Commission</div>
                <div className="font-semibold text-lg">₹{fmt(totals.comm)}</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                <div className="text-xs text-[#9aa4b2] mb-1">BuildCoins Awarded</div>
                <div className="font-semibold text-lg text-yellow-400">{fmt(totals.awarded)}</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                <div className="text-xs text-[#9aa4b2] mb-1">Initial BuildCoins</div>
                <div className="font-semibold text-lg">{fmt(totals.init)}</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                <div className="text-xs text-[#9aa4b2] mb-1">Redeemed BuildCoins</div>
                <div className="font-semibold text-lg text-red-400">₹{fmt(totals.redeemed)}</div>
              </div>
              <div className="bg-white/5 border border-white/10 rounded-xl p-3 text-center">
                <div className="text-xs text-[#9aa4b2] mb-1">Net Earnings</div>
                <div className="font-semibold text-lg text-green-500">₹{fmt(totals.net)}</div>
              </div>
            </div>
          </section>
        </div>

        <div className=" w-full">
          <section className="bg-gradient-to-b from-white/3 to-white/1.5 rounded-xl p-4 flex-[0.9] min-w-[280px] border border-white/10 shadow-[0_8px_30px_rgba(2,6,23,0.6)]">
            <h2 className="text-lg font-semibold mb-4 text-[#f9fafb]">Per-Project Dashboards</h2>
            <div className="space-y-4">
 {data.projects.map((p, pIdx) => {
  let sum = { est: 0, comm: 0, aw: 0, red: 0, lia: 0, net: 0 };
  const computedCats = computeCategoriesWithCarry(
    p.categories,
    p.initialBuildCoins ?? formValues.initialBuildCoins ?? 0,
    rounding
  );
  computedCats.forEach((m) => {
    sum.est += m.estOrder;
    sum.comm += m.estCommission;
    sum.aw += m.estBuildCoins;
    sum.red += m.estRedemption;
    sum.lia += m.estLiability;
    sum.net += m.estNet;
  });

  const awarded = sum.aw;
  const redeemed = sum.red;
  const gross = sum.comm;
  const initial = Number(p.initialBuildCoins ?? formValues.initialBuildCoins ?? 0);
  const liability = initial - sum.red + sum.aw;

  return (
    <div
      key={p.id}
      className="bg-white/5 border border-white/10 rounded-xl p-2 flex flex-col justify-between cursor-pointer"
      onClick={() => setSelectedProject(p)}
    >
      <div className="flex items-center gap-16 flex-wrap">
        <div className="flex flex-col ml-8 items-center justify-center">
          <span className="text-md font-semibold text-white">{p.name}</span>
          <span className="text-[#9aa4b2] text-sm mt-1">({p.id})</span>
        </div>

        <div className="flex flex-wrap gap-16">
          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">GOV</span>
            <span className="text-base font-semibold text-white mt-1">₹{fmt(sum.est)}</span>
          </div>

          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">Comm</span>
            <span className="text-base font-semibold text-white mt-1">₹{fmt(sum.comm)}</span>
          </div>

          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">BC Awarded</span>
            <span className="text-base font-semibold text-yellow-400 mt-1">{fmt(awarded)}</span>
          </div>

          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">Initial BC</span>
            <span className="text-base font-semibold mt-1">{fmt(formValues.initialBuildCoins)}</span>
          </div>

          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">Liability</span>
            <span className="text-base font-semibold text-purple-400 mt-1">{fmt(liability)}</span>
          </div>

          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">Net</span>
            <span className="text-base font-semibold text-green-500 mt-1">₹{fmt(sum.net)}</span>
          </div>

          <div className="flex flex-col items-center justify-center p-2 h-14 w-24">
            <span className="text-xs uppercase tracking-wide text-[#9aa4b2]">Redeemed</span>
            <span className="text-base font-semibold text-red-400 mt-1">₹{fmt(redeemed)}</span>
          </div>
        </div>
      </div>
    </div>
  );
})}

            </div>
          </section>
        </div>
      </main>

      {selectedProject && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-[#0f1d38] text-[#eef3fa] rounded-xl shadow-xl w-[90%] max-w-4xl max-h-[90vh] overflow-auto p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">{selectedProject.name} <span className="text-[#9aa4b2] text-sm">({selectedProject.id})</span></h3>
              <button onClick={() => setSelectedProject(null)} className="text-[#9aa4b2] hover:text-white">✕</button>
            </div>

            <div className="mb-4 text-sm text-[#9aa4b2]">
              {(() => {
                let sum = { est: 0, comm: 0, aw: 0, red: 0,lia: 0,net: 0 };
                const computedCats = computeCategoriesWithCarry(
                    selectedProject.categories,
                    selectedProject.initialBuildCoins ?? formValues.initialBuildCoins ?? 0,
                    rounding
                  );
                  computedCats.forEach((m) => {
                    sum.est += m.estOrder;
                    sum.comm += m.estCommission;
                    sum.aw += m.estBuildCoins;
                    sum.red += m.estRedemption;
                    sum.lia += m.estLiability;
                    sum.net += m.estNet;
                  });
                //const initialBuildCoins = selectedProject.initialBuildCoins || 0;
                const awarded = sum.aw; // BuildCoins awarded from categories only
                const redeemed = sum.red;
                const gross = sum.comm;
                const liability = sum.lia;
                const net = sum.net;

                return (
                  <>GOV ₹{fmt(sum.est)} · Comm ₹{fmt(sum.comm)} · BC Awarded {fmt(awarded)} · Initial BC {fmt(formValues.initialBuildCoins)} · Liability {fmt(liability)} · Net ₹{fmt(net)} · Redeemed ₹{fmt(redeemed)}</>
                );
              })()}
            </div>

            <table className="w-full border-collapse text-sm">
              <thead>
                <tr className="border-b border-white/10 text-[#9aa4b2] uppercase text-xs">
                  <th className="text-left py-2 px-3">Category</th>
                  <th className="text-left py-2 px-3">Est Order Value</th>
                  <th className="text-left py-2 px-3">Comm (%)</th>
                  <th className="text-left py-2 px-3">Reward (%)</th>
                  <th className="text-left py-2 px-3">Redemption (%)</th>
                  <th className="text-left py-2 px-3">Est Comm (₹)</th>
                  <th className="text-left py-2 px-3">Est BuildCoins</th>
                  <th className="text-left py-2 px-3">Est Redemption (₹)</th>
                  <th className="text-left py-2 px-3 cursor-pointer" title="Gross = Total commission earned from order">Gross (₹)</th>
                  <th className="text-left py-2 px-3 cursor-pointer" title="Liability = Rewards issued − Redemption (based on GOV × redemption%)">Liability (₹)</th>
                  <th className="text-left py-2 px-3 cursor-pointer" title="Net = Gross − Redemption - Liability">Net (₹)</th>
                </tr>
              </thead>
              <tbody>
 {(() => {
  const computedCats = computeCategoriesWithCarry(
    selectedProject.categories,
    selectedProject.initialBuildCoins ?? formValues.initialBuildCoins ?? 0,
    rounding
  );
  return selectedProject.categories.map((c, idx) => {
    const m = computedCats[idx];
    const estGross = m.estGross;
    const estLiability = m.estLiability;
    const estNet = m.estNet;
    console.log(m)
    return (
<tr key={c.name} className="border-b border-white/10">
  <td className="py-2 px-3">{c.name}</td>
  <td className="py-2 px-3">₹{fmt(c.estOrderValue)}</td>
  <td className="py-2 px-3">{c.commissionPct}%</td>
  <td className="py-2 px-3">{c.buildCoinsPct}%</td>
  <td className="py-2 px-3">{c.redemptionPct}%</td> {/* FIX: redemption% */}
  <td className="py-2 px-3 font-mono text-sm">₹{fmt(m.estCommission)}</td>
  <td className="py-2 px-3 font-mono text-sm text-yellow-400">₹{fmt(m.estBuildCoins)}</td>
  <td className="py-2 px-3 font-mono text-sm text-red-400">₹{fmt(m.estRedemption)}</td>
  <td className={`py-2 px-3 font-mono text-sm ${estGross < 0 ? "text-yellow-400" : "text-blue-400"}`}>
    ₹{fmt(estGross)}
  </td>
  <td className={`py-2 px-3 font-mono text-sm ${estLiability < 0 ? "text-yellow-400" : "text-purple-400"}`}>
    ₹{fmt(estLiability)}
  </td>
  <td className={`py-2 px-3 font-mono text-sm ${estNet < 0 ? "text-yellow-400" : "text-pink-400"}`}>
    ₹{fmt(estNet)}
  </td>
</tr>

    );
  });
})()}

              </tbody>
            </table>
          </div>
        </div>
      )}

      <footer className="mt-6 py-5 px-6 border-t border-white/10 text-center text-[#9aa4b2] text-sm">Brickbucket • BuildCoins & Commission Simulator · 2025</footer>
    </div>
  );
}
